<template>
  <div id='app'>
    <vue-navigation-bar :options='navbarOptions' />
    <transition mode='out-in' name='fade'>
      <router-view />
    </transition>

    <div id='footer'>
      <div id='footer-text'>
        <p>
          <a href='https://github.com/spencerwooo/portfolio'
          ><img
            alt='copyright'
            src='https://img.shields.io/badge/Designed%20by-github.com%2Fspencerwooo-black?logo=github&style=for-the-badge&labelColor=24292e'
          /></a>
        </p>

        <p>
          Built with ❤️ and
          <a href='https://vuejs.org/'>Vue.js</a>. Proudly deployed on <a href='https://www.aliyun.com/'>Aliyun .</a>
        </p>

        <p id='busuanzi_container_site_pv'>
          Viewed by you guys for a total of
          <span id='busuanzi_value_site_pv'></span> times ❤️
        </p>
        <p id='footer-copyright'>©2019 - {{ getYear() }} MoshiCoCo <br> <a href='https://beian.miit.gov.cn/'
                                                                           target='_blank'>豫ICP备17043261号-3</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-navigation-bar/dist/vue-navigation-bar.css'
import brandImage from './assets/images/av.png'

export default {
  name: 'app',

  data() {
    return {
      navbarOptions: {
        elementId: 'main-navbar',
        brandImagePath: './',
        brandImage,
        brandImageAltText: 'brand-image',
        showBrandImageInMobilePopup: true,
        collapseButtonOpenColor: '#661c23',
        collapseButtonCloseColor: '#661c23',
        mobileBreakpoint: 992,
        ariaLabelMainNav: 'Main Navigation',
        tooltipAnimationType: 'shift-away',
        tooltipPlacement: 'bottom',
        isUsingVueRouter: true,
        menuOptionsRight: [
          {
            type: 'link',
            text: 'Projects',
            path: '/projects',
          },
          {
            type: 'link',
            text: 'Social',
            path: '/social',
          },
          {
            type: 'link',
            text: 'Resume',
            path: '/resume',
          },
        ],

        menuOptionsLeft: [
          // {
          //   type: 'link',
          //   text: 'Home',
          //   path: '/',
          // },
          //   {
          //     type: 'button',
          //     text: 'Projects',
          //     path: '/projects',
          //   },
          //   {
          //     type: 'button',
          //     text: 'Social',
          //     path: '/social',
          //   },
          //   {
          //     type: 'button',
          //     text: 'Resume',
          //     path: '/resume',
          //   },
        ],

      },
    }
  },
  methods: {
    getYear() {
      return new Date().getFullYear()
    },
  },
}
</script>

<style>
.container {
  margin: 0px auto 0px auto;
  max-width: 664px;
  padding: 0px 20px 40px 20px;
}

#main-navbar {
  padding-right: 8px;
  background-color: #fafafa;
}

.vnb__collapse-button img {
  width: 24px;
  height: 24px;
  padding-bottom: 3px;
}

.vnb__menu-options--right {
  margin-left: 0;
  padding-left: 10px;
  margin-right: 8px
}

.vnb__popup__top__close-button {
  padding-top: 10px;
}


.vnb__brand-image-wrapper__link__image {
  max-height: 30px;
  margin-left: 8px;
  margin-top: 8px;
}

.vnb__menu-options__option a {
  font-size: 20px;
}

.vnb__menu-options__option a:focus {
  outline: none;
}

.vnb__popup__bottom__menu-options__option__link {
  padding: 6px 24px;
}

.vnb__popup__bottom__menu-options__option__link:focus {
  border-left: 2px solid #0070f3;
}

#footer {
  padding: 20px 20px;
  background-color: #000;
}

#footer p {
  color: var(--footer-color);
  line-height: initial;
}

#footer-text {
  margin: 0px auto;
  max-width: 664px;
  color: #ffffff;
}

#footer-text a,
#busuanzi_value_site_pv,
#footer-copyright {
  color: #ffffff;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
